/** The rules page is product-neutral now that one rule covers both products. */
export const BIDDER_RULES_PATH = '/monetization/inventory/bidder-rules'
